
import React from 'react';
import { CheckCircle } from 'lucide-react';

const TelemarketingInfoSection: React.FC = () => {
  return (
    <section className="section bg-white">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="section-title">Realistische prijsbepaling van telefonische prospectie</h2>
            <div className="space-y-6">
              <p className="text-gray-700">
                Bij Afsprakenmaker.be begrijpen we dat elke telefonische prospectie uniek is. Met onze gedetailleerde calculator krijg je een realistische inschatting, geen loze beloften.
              </p>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="bg-brand-red rounded-full p-1 mt-1 text-white">
                    <CheckCircle size={16} />
                  </div>
                  <p className="text-gray-700">We houden rekening met complexiteit, DMU, taal en sector</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="bg-brand-red rounded-full p-1 mt-1 text-white">
                    <CheckCircle size={16} />
                  </div>
                  <p className="text-gray-700">De marktgrootte bepaalt mede het haalbare aantal afspraken</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="bg-brand-red rounded-full p-1 mt-1 text-white">
                    <CheckCircle size={16} />
                  </div>
                  <p className="text-gray-700">Transparante prijsberekening op basis van alle relevante factoren</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="bg-brand-red rounded-full p-1 mt-1 text-white">
                    <CheckCircle size={16} />
                  </div>
                  <p className="text-gray-700">We waarschuwen als je verwachtingen niet realistisch zijn</p>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img 
              src="https://images.unsplash.com/photo-1521791136064-7986c2920216" 
              alt="KMO bedrijfsleider" 
              className="w-full h-auto rounded-lg shadow-md object-cover aspect-[4/3]"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default TelemarketingInfoSection;
